<template>
  <div class="form-group">
    <div class="col-lg-4">
      <label class="control-label">
        Extras
      </label>
      <p class="help-block">
        Please select any extras that are on this vehicle
      </p>
    </div>
    <div class="col-lg-8">
      <div
        class="checkbox"
        :key="extraIndex"
        v-for="(extra, extraIndex) in extras"
        :class="{ 'checkbox-inline': useAsFilter }"
      >
        <label>
          <input
            type="checkbox"
            :value="extra.id"
            @click="toggleExtra(extra)"
            :checked="selected(extra)"
          />
          {{ extra.label }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    extras: {
      type: Array,
      required: true
    },
    useAsFilter: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    innerValue: {
      get() {
        return this.value;
      },

      set: function(extras) {
        this.$emit('input', extras);
      }
    }
  },

  methods: {
    toggleExtra(extra) {
      const index = this.innerValue.indexOf(extra.id);

      if (index > -1) {
        this.innerValue.splice(index, 1);
      } else {
        this.innerValue.push(extra.id);
      }
    },

    selected(extra) {
      return this.innerValue.indexOf(extra.id) > -1;
    }
  }
};
</script>
<style scoped>
.checkbox-inline {
  display: inline-block;
  margin-right: 30px;
}

.checkbox-inline label {
  cursor: pointer;
  margin-bottom: 0;
}

.checkbox-inline input[type='checkbox'] {
  position: relative;
  top: -1px;
  margin-right: 5px;
}
</style>
